import React from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
// import UploadIcon from "@mui/icons-material/Upload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useEffect } from "react";
import swal from "sweetalert";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import layOutDefault from "../../../assets/Images/layout-defaullt-img2.jpg";
import Zoom from "react-medium-image-zoom";

// import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import SearchIcon from "@mui/icons-material/Search";
// import SortIcon from "@mui/icons-material/Sort";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";

import {
  makeGetRequest,
  makePostRequest,
  uploadFileRequest,
} from "../../../utils/utils";

const Validation_Schema = Yup.object().shape({
  spotName: Yup.string().required("Required"),
  // .matches(
  //   /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
  //   "Numbers not allowed!!"
  // ),
  latitude: Yup.string()
    .required("Required")
    .matches(/^\d+(\.\d)?\d*$/, "Invalid Latitude"),

  longitude: Yup.string()
    .required("Required")
    .matches(/^\d+(\.\d)?\d*$/, "Invalid Logitude"),

    guardCnt:Yup.number().required("Required")

  // spot_layout: Yup.string().required("Required"),
});

function AddNewSpot() {
  const navigate = useNavigate();

  const [selected, setSelected] = React.useState(false);

  // For memu
  // const [anchorEl10, setAnchorEl10] = React.useState(null);
  // const open10 = Boolean(anchorEl10);
  // const handleClick10 = (event) => {
  //   setAnchorEl10(event.currentTarget);
  // };
  // const handleClose10 = () => {
  //   setAnchorEl10(null);
  // };
  // End

  // For memu
  const [anchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
  // End

  const [spotId, setSpotId] = React.useState("");
  const [spotName, setSpotName] = React.useState("");
  const [guardCnt, setguardCnt] = React.useState();
  const [longitude, setLongitude] = React.useState("");
  const [latitude, setLatitude] = React.useState("");
  const [spotlayout, setSpotLayout] = React.useState("");
  const [spotList, setSpotList] = React.useState([]);
  const [isEditSpot, setIsEditSpot] = React.useState(false);
  const [q, setQ] = React.useState("");
  const [showLoader, setShowLoader] = React.useState(false);
  const [Upload,setUpload]=React.useState(false);
  const [sortBy,setSortBy]=React.useState("");

  const [spotNameErrMsg,setSpotNameErrMsg]=React.useState("");

  useEffect(() => {
    GetSpotsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q,Upload]);

  // const [value, setValue] = React.useState(0);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  var formikInitialsSpots = {
    spotName: spotName,
    latitude: latitude,
    longitude: longitude,
    guardCnt:guardCnt,
  };

  async function editSpot(spotData) {

    console.log("Edit Spot")
    console.log(spotData);
    setSpotNameErrMsg("");
    setIsEditSpot(true);
    setSpotId(spotData.spot_id);
    setSpotLayout(spotData.spot_layout);
    setSpotName(spotData.spot_name);
    setLatitude(spotData.latitude);
    setLongitude(spotData.longitude);
    setguardCnt(spotData.guard_count)
  }

  async function cancelSpot() {
    setIsEditSpot(false);
    setSpotId("");
    setguardCnt("");
    setSpotLayout("");
    setSpotName("");
    setLatitude("");
    setLongitude("");
    setLayoutErrMsg("");
    setSpotNameErrMsg("");
  }

  async function handleChangeSortBy()
  {
    alert(sortBy)
    if(sortBy=="")
      setSortBy("ASC")
    else if(sortBy=="DESC")
      setSortBy("ASC")
    else if(sortBy=="ASC")
      setSortBy("DESC")
    setUpload(!Upload);
    GetSpotsList();
  }

  async function addSpot() {

    setSpotNameErrMsg("");
    let availableSpot;
    let spotData={
      spotName:spotName
    }

    await makePostRequest("spot/getbyname", spotData)
        .then((response) => {
          // checked codition if responce is empty
          if (response.data.data !== undefined) {

            if(isEditSpot)
            {
              if(response.data.data.spot_id==spotId)
              {
                availableSpot=false
              }
              else{
                availableSpot=true;
              }
            }
            else
                availableSpot=true;
           
            
          }
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });

    if(availableSpot)
    {
        setSpotNameErrMsg("Spot Is already available with same name")
    }
    else{
      
    if (isEditSpot) {
      setShowLoader(true);
      let inputdata = {
        spot_id: spotId,
        guard_count:guardCnt,
        spot_name: spotName,
        latitude: latitude,
        longitude: longitude,
        spot_layout: spotlayout,
      };
      console.log(inputdata);
      await makePostRequest("spot/update", inputdata)
        .then((response) => {
          // checked codition if responce is empty
          if (response.data.data !== undefined) {
            localStorage.setItem("spotid", response.data.data.spot_id);
            swal("Success", "spot updated successfully", "success", {
              timer: 3000,
              buttons: false,
            });
            
            GetSpotsList();
            cancelSpot();
          }
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      setShowLoader(true);
      let inputdata = {
        spot_name: spotName,
        guard_count:guardCnt,
        latitude: latitude,
        longitude: longitude,
        spot_layout: spotlayout,
      };
      await makePostRequest("spot/insert", inputdata)
        .then((response) => {
          // checked codition if responce is empty
          if (response.data.data !== undefined) {
            localStorage.setItem("spotid", response.data.data.spot_id);
            swal("Success", "Spot added successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            // window.location.reload();
            cancelSpot();
            
            GetSpotsList();
          }
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    }

    }

    // document.getElementById("residentSubBtn").disabled = true;
  }

  async function GetSpotsList() {

    let bodyFormData = {
    };

    if(q)
    {
      bodyFormData.searchString=q;
    }
    if(sortBy)
    {
      bodyFormData.sortBy=sortBy;
    }
   
    setShowLoader(true);
    await makePostRequest("spot/getalllist", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log(response.data.data);
          setSpotList(response.data.data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  //Spot delete
  async function deleteSpot(spot_id) {
    const willDelete = await swal({
      title: "Are you sure?",
      text: "Do you really want to delete this record? This process cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["No", "Yes"],
    });

    if (willDelete) {
      var bodyFormData = new FormData();
      await makeGetRequest("spot/delete/" + spot_id, bodyFormData)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Record deleted successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            cancelSpot();
            GetSpotsList();
          } else {
            swal("Error", "Failed to delete", "error");
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
          console.log(err);
        });
    }
  }

  const [layoutErrMsg, setLayoutErrMsg] = React.useState("");

  async function validateImage(fileData) {
    if (fileData.name.match(/.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF)$/i))
      return true;
    else return false;
  }

  async function uploadLayout(e) {
    setLayoutErrMsg("");
    const fileData = e.target.files[0];

    if (await validateImage(fileData)) {
      const formData = new FormData();
      formData.append("image", fileData);
      var fileUrl;

      setShowLoader(true);
      await uploadFileRequest("guards/uploadImages", formData).then(
        (response) => {
          fileUrl = response.data.imagepath[0].location;
          console.log(response.data.imagepath[0]);
        }
      );
      setSpotLayout(fileUrl);
      setShowLoader(false);
    } else {
      setLayoutErrMsg("Invalid file format");
    }
  }

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/ConfigureSecuritySpots")}
              />
              {isEditSpot ? <> Update Spot</> : <> Add Spot</>}
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            {/* <div className="residentHeading">Add Spot</div> */}
            <div className="addSocietyMain">
              <div className="addSocietyInnerMain" style={{ marginTop: 15 }}>
                <Formik
                  enableReinitialize
                  initialValues={formikInitialsSpots}
                  validationSchema={Validation_Schema}
                  onSubmit={addSpot}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                          <div className="uploadImDiv">
                            <div className="uploadIm">
                              {/* <img src={spotlayout} /> */}
                              <Zoom>
                                {spotlayout ? (
                                  <img src={spotlayout} />
                                ) : (
                                  <img src={layOutDefault} />
                                )}
                              </Zoom>
                            </div>
                            <div className="uploadInpu">
                              <FileUploadIcon />
                              <span>Upload Spot layout</span>
                              <em className="uploadPhotoErrorMsg">
                                {layoutErrMsg}
                              </em>
                              <input
                                type="file"
                                id="spot_layout"
                                value={values.spotlayout}
                                onChange={(event) => uploadLayout(event)}
                              />
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Spot Name</label>
                          <input
                            className="inputSt"
                            type="text"
                            value={values.spotName}
                            placeholder="Spot Name"
                            onChange={handleChange("spotName")}
                            onBlur={() => setFieldTouched("spotName")}
                            onChangeCapture={(e) => setSpotName(e.target.value)}
                          />
                          {errors.spotName && touched.spotName ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.spotName}
                            </div>
                          ) : <div
                          style={{ color: "red" }}
                          className="errorField"
                        >
                          {spotNameErrMsg}
                        </div>}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">
                            Guard Count (Full Description Here..)
                          </label>
                          <input
                            className="inputSt"
                            placeholder="Guard Count"
                            value={values.guardCnt}
                            maxLength={1}
                            onBlur={() => setFieldTouched("guardCnt")}
                            onChangeCapture={(e) => setguardCnt(e.target.value)}
                          />
                          {errors.guardCnt && touched.guardCnt ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.guardCnt}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Latitude</label>
                          <input
                            className="inputSt"
                            type="text"
                            value={values.latitude}
                            placeholder="Latitude"
                            onChange={handleChange("latitude")}
                            onBlur={() => setFieldTouched("latitude")}
                            onChangeCapture={(e) => setLatitude(e.target.value)}
                          />
                          {errors.latitude && touched.latitude ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.latitude}
                            </div>
                          ) : null}{" "}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <label className="tabsLabel">Longitude</label>
                          <input
                            className="inputSt"
                            type="text"
                            value={values.longitude}
                            placeholder="Longitude"
                            onChange={handleChange("longitude")}
                            onBlur={() => setFieldTouched("longitude")}
                            onChangeCapture={(e) =>
                              setLongitude(e.target.value)
                            }
                          />
                          {errors.longitude && touched.longitude ? (
                            <div
                              style={{ color: "red" }}
                              className="errorField"
                            >
                              {errors.longitude}
                            </div>
                          ) : null}{" "}
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <div
                            className="addOwnerTopLine cancelBtForAllOuter"
                            style={{ textAlign: "center" }}
                          >
                            {isEditSpot ? (
                              <Button
                                className="addBt cancelBtForAll"
                                onClick={() => cancelSpot()}
                              >
                                Cancel
                              </Button>
                            ) : (
                              <></>
                            )}
                            <Button
                              className="addBt"
                              type="submit"
                              // onClick={() => addSpot(spotId)}
                            >
                              {isEditSpot ? (
                                <div> Update</div>
                              ) : (
                                <div> Add</div>
                              )}
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
                <Grid item xs={12} md={12}>
                  <div className="spotTailsOuter">
                    <div className="visitorSearch">
                      <div className="visitorSearchDiv">
                        <SearchIcon className="visitorSearchIco" />
                        <input
                          type="text"
                          placeholder="Search"
                          onChangeCapture={(e) => setQ(e.target.value)}
                        />
                        {/* <MicIcon className="visitorMicIco" />  */}
                      </div>

                      {/* <div>
                       // Statics
                        <SortIcon
                          className="visitorFilterIco"
                          aria-controls={open10}
                          aria-haspopup="true"
                          aria-expanded={open10}
                          onClick={handleClick10}
                        />
                        <Menu
                          anchorEl={anchorEl10}
                          open={open10}
                          onClose={handleClose10}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          <MenuItem onClick={handleClose10}>
                            Filter Item 1
                          </MenuItem>
                          <MenuItem onClick={handleClose10}>
                            Filter Item 2
                          </MenuItem>
                          <MenuItem onClick={handleClose10}>
                            Filter Item 3
                          </MenuItem>
                        </Menu>
                      </div> */}

                      <div className="sortingIcoOut">
                        {/* Statics */}
                        <ToggleButton
                          value="check"
                          selected={selected}
                          onChange={() => {
                            setSelected(!selected);
                          }}
                        >
                          <ImportExportIcon
                            className="visitorFilterIco"
                            aria-controls={open}
                            aria-haspopup="true"
                            aria-expanded={open}
                            onClick={handleChangeSortBy}
                          />
                        </ToggleButton>
                      </div>
                    </div>

                    {spotList.map((option) => (
                      <div className="visitContDiv">
                        <div className="visitCont1 resideNewContOut">
                          <div className="visitContProf">
                            {option.spot_layout ? (
                              <img src={option.spot_layout} />
                            ) : (
                              <img src={layOutDefault} />
                            )}
                          </div>
                          <div className="visitContLeft">
                            <h3 className="visitContHed">{option.spot_name}</h3>
                          </div>
                          <div className="visitBottCont">
                            <p>Latitude</p>
                            <b>{option.latitude}</b>
                          </div>
                          <div className="visitBottCont">
                            <p>Longitude</p>
                            <b>{option.longitude}</b>
                          </div>
                          <div className="resideNewCont">
                            <CreateIcon
                              className="editBt"
                              onClick={() => editSpot(option)}
                            />
                            <DeleteIcon
                              className="deleteBt"
                              onClick={() => deleteSpot(option.spot_id)}
                            />
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* <div className="listPaginationMain">
                      <Stack spacing={2}>
                        <Pagination
                          count={10}
                          variant="outlined"
                          shape="rounded"
                        />
                      </Stack>
                    </div> */}
                  </div>
                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default AddNewSpot;
